module.exports = __webpack_public_path__ + "static/media/defaultBcg.fe25de40.jpeg";